
import React from 'react';
import App from './../../App';
import { isMobile, isAndroid, isIOS, isSafari } from 'react-device-detect';
import Register from '../register/Register';
import SimpleContext from '../context/SimpleContext';
import { useContext } from 'react';
import UseMobile from './UseMobile';

const PC_OR_Mob = () => {
  const context = useContext(SimpleContext)
  if ( (isIOS || isAndroid || isSafari || isMobile) === true) {
    return <App/>
  }

  else{
    return <UseMobile/>
  }

};
export default PC_OR_Mob;

